import { MdMeetingRoom } from "react-icons/md";
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { IoArrowBackOutline } from "react-icons/io5";
import { SiWelcometothejungle } from "react-icons/si";
import { FaUserTie } from "react-icons/fa6";
import { FaUser } from "react-icons/fa6";
import { IoIosSend } from "react-icons/io";
import { PiIdentificationCardLight } from "react-icons/pi";

export const icons = {
  Room: MdMeetingRoom,
  Name: MdOutlineDriveFileRenameOutline,
  Back: IoArrowBackOutline,
  Welcome: SiWelcometothejungle,
  User: FaUserTie,
  User1: FaUser,
  Send: IoIosSend,
  Id: PiIdentificationCardLight,
};
